import { render, staticRenderFns } from "./SelectCompetitors.vue?vue&type=template&id=32a149c5&scoped=true&"
import script from "./SelectCompetitors.vue?vue&type=script&lang=js&"
export * from "./SelectCompetitors.vue?vue&type=script&lang=js&"
import style0 from "./SelectCompetitors.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectCompetitors.vue?vue&type=style&index=1&id=32a149c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a149c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VProgressLinear,VRow,VSpacer,VTextField,VTooltip})
